export enum IntegrationType {
    Reddit = 'reddit',
    AlphaVantage = 'alpha_vantage',
}
export interface Integration {
    integrationType: IntegrationType;
    status: 'connected' | 'disconnected';
}
